export default {
  namespaced: true,
  state: {
    worker: null,
  },
  getters: {
    worker: state => state.worker,
  },
  mutations: {
    setWorker(state, worker) {
      state.worker = worker;
    },
  },
  actions: {
    initializeWorker({ commit, dispatch, getters }, worker){
      commit('setWorker', worker)
      getters.worker.onmessage = (e) => {
        dispatch('contents/onReceiveWorkerMessage', e.data, { root: true })
      }
    }, 
    backgroundTask({ getters } , args){ 
      if(!getters.worker) return;
      args.messages.forEach(message => {
        getters.worker.postMessage(JSON.stringify(message))
      });
    },
  }
}
